import React from "react";
import Header from "../header2/Header";
const UserPayment = () => {
  return (
    <>
      <section className="section-top">
        <Header />
        <img
          className="img-fluid w-100"
          src="assest/photos/payment-gateway.jpg"
          alt="G-Rank"
        />
      </section>
    </>
  );
};

export default UserPayment;
